<template>
  <div class="page_top">
    <PageBasePc msg="客服">
      <div class="kefu_main">
        <div class="kefu_item" v-for="(item, index) in kefus" :key="index">
          <img class="kefu_item_img" :src="item.img" alt="">
          <div class="kefu_msg">
            <div class="kefu_name">【 {{item.name}} 】</div>
            <div class="kefu_space"></div>
            <div class="kefu_code">
              {{item.code}}
            </div>
            <div class="kefu_type">
              【{{item.type}}】
            </div>
          </div>
        </div>
      </div>
    </PageBasePc>
  </div>
</template>

<script>
// @ is an alias to /src
// import Clipboard from 'clipboard'
import PageBasePc from '@/components/PageBasePc.vue'

export default {
  name: 'ServiceMobile',
  components: {
    PageBasePc
  },
  data: () => {
    return {
    }
  },
  mounted () {
    this.onToTop()
  },
  methods: {
    onToTop () {
      document.body.scrollTop = document.documentElement.scrollTop = 0
    }
  },
  computed: {
    kefus () {
      return this.$store.state.configs.kefus
    }
  }
}
</script>
<style scoped>
.kefu_main {

}
.kefu_title {
  text-align: left;
  margin-bottom: 1rem;
}
.kefu_item {
  margin: 1rem 0.7rem;
  text-align: right;
  float: left;
  position: relative;
}
.kefu_item_img {
  height: 12rem;
}
.kefu_name {
  font-size: 0.8rem;
  margin-bottom: 0.3rem;
}
.kefu_space {
  border-bottom: 1px rgba(0,0,0,0.1) solid;
  margin: 1rem 2.5rem;
}
.kefu_code {
  font-size: 0.8rem;
  margin-top: -0.2rem;
}
.kefu_msg {
  position: absolute;
  right: 0rem;
  top: 2rem;
  width: 8rem;
  text-align: center;
}
.kefu_type {
  font-size: 0.8rem;
  color: #ff9500;
}
.copy_but {
  margin-left: 1.2rem;
  cursor: pointer;
  border: 1px rgb(38, 118, 160) solid;
  border-radius: 3px;
  color: rgb(246,247,251);
  padding: 1px 6px 3px 6px;
  background: rgb(48, 150, 206);
  font-size: 0.8rem;
}
.toast_main {
  position: fixed;
  top: 50%;
  width: 100%;
  z-index: 99999;
}
.toast_div {
  border: 1px #666 solid;
  padding: 1rem 2rem;
  border-radius: 3px;
  background: #fff;
  color: #666;
}
</style>
